module.exports = __webpack_public_path__ + "media/shanghai.be3132c9.mp3";